import script from "./DiagonalWithGradient.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagonalWithGradient.vue?vue&type=script&setup=true&lang=js"

import "./DiagonalWithGradient.vue?vue&type=style&index=0&id=59d36d6e&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d36d6e"]])

export default __exports__